var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2424_21605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0598 2H11.0293V7.15682H20.0598V2Z",
    fill: "#ECF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3124 11.4216H11.0293V16.5785H24.3124V11.4216Z",
    fill: "#ECF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3921 20.8433H10.2598V26.0001H27.3921V20.8433Z",
    fill: "#ECF4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0598 2H11.0293V7.15682H20.0598V2Z",
    stroke: "#24293D",
    strokeWidth: 1.52749,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75252 2H1.5957V7.15682H6.75252V2Z",
    stroke: "#24293D",
    strokeWidth: 1.52749,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3124 11.4216H11.0293V16.5785H24.3124V11.4216Z",
    stroke: "#24293D",
    strokeWidth: 1.52749,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5957 16.5785H6.75252V11.4216H1.5957",
    stroke: "#24293D",
    strokeWidth: 1.52749,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2598 26.0001H27.4044V20.8433H10.2598",
    stroke: "#24293D",
    strokeWidth: 1.52749,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75252 20.8433H1.5957V26.0001H6.75252V20.8433Z",
    stroke: "#24293D",
    strokeWidth: 1.52749,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2424_21605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/manage.0fe1337523703f3264e2b6237ebf609e.svg";
export { ForwardRef as ReactComponent };